import type { ReactNode } from 'react'

import { Container } from './Container'
import { Header } from './Header'
import { IconWrapper } from './IconWrapper'
import { Subtitle } from './Subtitle'
import { Title } from './Title'
import { TitleWrapper } from './TitleWrapper'

type Props = {
	title: NonNullable<ReactNode>
	subtitle?: ReactNode
	icon: NonNullable<ReactNode>
	children?: ReactNode
}

export const ItemCard = ({ title, subtitle, icon, children }: Props) => (
	<Container>
		<Header>
			<IconWrapper>{icon}</IconWrapper>
			<TitleWrapper>
				<Title>{title}</Title>
				{subtitle && <Subtitle>{subtitle}</Subtitle>}
			</TitleWrapper>
		</Header>
		{children && <div>{children}</div>}
	</Container>
)
